import { render, staticRenderFns } from "./Duplix.vue?vue&type=template&id=b85c0988&scoped=true&"
import script from "./Duplix.vue?vue&type=script&lang=js&"
export * from "./Duplix.vue?vue&type=script&lang=js&"
import style0 from "./Duplix.vue?vue&type=style&index=0&id=b85c0988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85c0988",
  null
  
)

export default component.exports